import axios from "axios";
import { store } from "../index";
import { loginSuccess, logout } from "../slices/user/reducer";
import { toast } from "react-toastify";
import i18n from "../i18n";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

axios.defaults.baseURL = API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;

const privateAPI = axios.create({ baseURL: API_URL });
privateAPI.defaults.headers.post["Content-Type"] = "application/json";
privateAPI.defaults.withCredentials = true;

const token = localStorage.getItem("persist:root") ? JSON.parse(JSON.parse(localStorage.getItem("persist:root")).user ? JSON.parse(localStorage.getItem("persist:root")).user : '{}')?.currentUser?.token : null;

if (token) { privateAPI.defaults.headers.authorization = "Bearer " + token; }

//Set Authorization header
privateAPI.interceptors.request.use(
  (config) => {
    const token = store.getState()?.user?.currentUser?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

//Refresh token on expired token
privateAPI.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError" || error?.message === "canceled") {
      return Promise.reject(error);
    }
    let message = error?.response?.data;
    const originalRequest = error.config;
    if (error.response?.status === 401) {
      const responseMessage = error.response?.data?.message || "";
      // Account deleted or deactivated - skip refresh, logout immediately
      if (responseMessage === "Sesja jest nieważna. Zaloguj się ponownie.") {
        store.dispatch(logout());
        toast.dismiss();
        toast(i18n.t('common.sessionExpired'), { position: 'bottom-right', className: "bg-danger text-white", autoClose: 2000 });
        return Promise.reject(message);
      }

      if (!originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const res = await axios.post('/auth/refresh', {}, { withCredentials: true });
          store.dispatch(loginSuccess(res.data));
          originalRequest.headers.authorization = `Bearer ${res.data.token}`;
          return privateAPI(originalRequest);
        } catch (error) {
          store.dispatch(logout());
          toast.dismiss();
          toast(i18n.t('common.sessionExpired'), { position: 'bottom-right', className: "bg-danger text-white", autoClose: 1000 });
          if (error.response?.data) {
            message = error.response.data;
          }
        }
      }
    }
    return Promise.reject(message);
  }
);

//Public axios instacne
const publicAPI = axios.create({ baseURL: API_URL });
publicAPI.defaults.headers.post["Content-Type"] = "application/json";
publicAPI.defaults.withCredentials = true;

// intercepting to capture errors
publicAPI.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError" || error?.message === "canceled") {
      return Promise.reject(error);
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    if (error.response?.data) {
      message = error.response.data
    } else {
      switch (error.status) {
        case 500:
          message = "Internal Server Error";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the data you are looking for could not be found";
          break;
        default:
          message = error.message || error;
      }
    }
    return Promise.reject(message);
  }
);


export { publicAPI, privateAPI, API_URL };

